import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import BrandLogo from "@/components/app/BrandLogo";
import { toast } from "sonner";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (user && user !== false) {
      const map = { admin: "/admin", technician: "/tech" };
      navigate(map[user.role] || "/login");
    }
  }, [user, navigate]);

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true); setErr("");
    const res = await login(email, password);
    setLoading(false);
    if (!res.ok) { setErr(res.error); toast.error(res.error); return; }
    toast.success(`Welcome, ${res.user.name}`);
    const map = { admin: "/admin", technician: "/tech" };
    navigate(map[res.user.role] || "/login");
  }

  return (
    <div className="min-h-screen bg-[#05070d] text-slate-100 flex items-center justify-center px-4 py-10 relative">
      <div className="absolute inset-0 bg-grid opacity-30" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-slate-950" />
      <div className="relative w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 justify-center mb-8">
          <BrandLogo height={56} />
          <div className="leading-tight text-left border-l border-slate-800 pl-3">
            <div className="font-display font-extrabold text-xl text-purple-300">GOA</div>
            <div className="text-[10px] font-mono-alt uppercase tracking-widest text-slate-500">Ops sign-in</div>
          </div>
        </Link>

        <form onSubmit={onSubmit} className="tactical-card p-6 space-y-5">
          <div>
            <h1 className="font-display text-2xl font-bold text-white">Sign in</h1>
            <p className="text-sm text-slate-400 mt-1">Office staff & technicians only.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Username</Label>
            <Input data-testid="login-email" id="email" type="text" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="e.g. rahul" className="bg-slate-900 border-slate-700" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input data-testid="login-password" id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="bg-slate-900 border-slate-700" />
          </div>
          {err && <div data-testid="login-error" className="text-sm text-rose-400 bg-rose-500/10 border border-rose-500/30 rounded-md p-2">{err}</div>}
          <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full bg-purple-500 hover:bg-purple-600 h-11">
            {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Sign in
          </Button>
        </form>
      </div>
    </div>
  );
}
